///
/// A video player, in an overlay, with a close button.
///

import {Box} from '@material-ui/core'
import Hls from 'hls.js'
import {useEffect, useRef} from 'react'
import {ButtonBox, CloseButton, ContentBox, VideoBackdrop} from './styled'

type VideoPlayerProps = {
  streamingURL: string | undefined
  onClose: () => void
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({streamingURL, onClose}: VideoPlayerProps) => {
  const videoRef = useRef(null)

  useEffect(() => {
    let hls: Hls
    const video = videoRef.current
    if (video && streamingURL) {
      if (Hls.isSupported()) {
        // This will run in all other modern browsers
        hls = new Hls()
        hls.loadSource(streamingURL)
        hls.attachMedia(video)
      } else {
        console.error("This is a legacy browser that doesn't support MSE")
      }
    }

    return () => {
      if (hls) {
        hls.destroy()
      }
    }
  }, [videoRef, streamingURL])

  if (streamingURL) {
    return (
      <Box>
        <VideoBackdrop open={true}>
          <ButtonBox display="flex">
            <CloseButton onClick={() => onClose()}>Close</CloseButton>
          </ButtonBox>
          <ContentBox display="flex">
            <video controls ref={videoRef} style={{width: '100%', maxWidth: '500px'}} />
          </ContentBox>
        </VideoBackdrop>
      </Box>
    )
  } else {
    return null
  }
}

export default VideoPlayer
